module.exports = __webpack_public_path__ + "img/微信4.a05f938.png";